import {useEffect, useState} from 'react';
import {Platform} from 'react-native';
import MapView, {Marker as NativeMarker} from 'react-native-maps';
import {getApps, GetAppResult} from 'react-native-map-link';
import {useTheme} from 'styled-components/native';

import {
  SectionTitle,
  StationCard,
  StationMapButton,
  StationMap,
  StationMarkerImage,
  StationInfosRow,
  StationInfosContainer,
  StationImage,
  StationInfos,
  StationTitle,
  StationDescription,
  StationMapIcon,
  LinkButtonContainer,
  MapSheetContainer,
  MapSheetTitle,
  MapSheetOption,
  MapSheetOptionIcon,
  MapSheetOptionText,
} from './styles';

import {useNavigation} from '@react-navigation/native';

import {StationDTO} from '../../../dtos/StationDTO';

import {StationsModal} from '../Stations/StationsModal';
import {Button} from '../../Interface/Forms/Buttons/Button';
import BottomSheet from '../../Interface/BottomSheet';

interface GasStationLocationsProps {
  posto: StationDTO;
  stationsByProductId: StationDTO[];
  showMap?:boolean;
  localidade: {
    rank: string;
    tipo: string;
    region: string;
    estado: string;
    cidade: string;
  };
}

export function GasStationLocations({
  posto,
  stationsByProductId,
  localidade,
  showMap = false,
}: GasStationLocationsProps) {

  const navigation = useNavigation();
  const theme = useTheme();

  //@ts-ignore react-native-web-maps only exposes Marker as a MapView static, not a named export
  const MapMarker = Platform.OS === 'web' ? MapView.Marker : NativeMarker;

  const [showStationsModal, setStationsModal] = useState(false);
  const [showMapAppsSheet, setShowMapAppsSheet] = useState(false);
  const [mapApps, setMapApps] = useState<GetAppResult[]>([]);

  useEffect(() => {
    async function loadMapApps() {
      const apps = await getApps({
        appsWhiteList: ['waze', 'google-maps'],
        directionsMode: 'car',
        latitude: posto.lat,
        longitude: posto.lng,
      });

      setMapApps(apps);
    }

    loadMapApps();
  }, [posto.lat, posto.lng]);

  return (
    <>
      <>
        <SectionTitle>Local de abastecimento:</SectionTitle>
        <StationCard>
          {
            showMap && <StationMapButton
            activeOpacity={0.8}
            onPress={() => setShowMapAppsSheet(true)}>
            <StationMap
              region={{
                latitude: posto.lat,
                longitude: posto.lng,
                latitudeDelta: 0.003,
                longitudeDelta: 0.003,
              }}
              customMapStyle={theme.mapstyle}
              scrollEnabled={false}
              zoomEnabled={false}
              rotateEnabled={false}
              pitchEnabled={false}
              toolbarEnabled={false}
              pointerEvents="none">

                <MapMarker
                  coordinate={{
                    latitude: posto.lat,
                    longitude: posto.lng,
                  }}>
                  <StationMarkerImage source={{uri: posto.flag_image}} />
                </MapMarker>

            </StationMap>
          </StationMapButton>

          }

          <StationInfosRow
            activeOpacity={0.7}
            onPress={() => navigation.navigate('Station', {item: posto})}>
            <StationInfosContainer>
              <StationImage source={{uri: posto.flag_image}} />
              <StationInfos>
                <StationTitle numberOfLines={1} ellipsizeMode="tail">
                  {posto.name}
                </StationTitle>
                <StationDescription numberOfLines={1} ellipsizeMode="tail">
                  {posto.neighbourhood}
                </StationDescription>
              </StationInfos>
            </StationInfosContainer>

            <StationMapIcon name="chevron-right" />
          </StationInfosRow>
        </StationCard>
        {stationsByProductId.length > 0 && (
          <LinkButtonContainer>
            <Button
              title="Ou também abasteça nestes locais"
              testID="openDiscountScreen"
              size="small"
              variant="secondary"
              onPress={() => setStationsModal(true)}
            />
          </LinkButtonContainer>
        )}
      </>

      <BottomSheet
        isOpen={showMapAppsSheet}
        onClose={() => setShowMapAppsSheet(false)}>
        <MapSheetContainer>
          <MapSheetTitle>Abrir localização em qual app?</MapSheetTitle>

          {mapApps.map(app => (
            <MapSheetOption
              key={app.id}
              activeOpacity={0.7}
              onPress={() => {
                setShowMapAppsSheet(false);
                app.open();
              }}>
              <MapSheetOptionIcon source={app.icon} />
              <MapSheetOptionText>{app.name}</MapSheetOptionText>
            </MapSheetOption>
          ))}
        </MapSheetContainer>
      </BottomSheet>

      <StationsModal
        onDismiss={() => setStationsModal(false)}
        data={stationsByProductId}
        tipo={localidade.tipo}
        showModal={showStationsModal}
        showRank={false}
      />
    </>
  );
}
